// selectedRowSlice.js
import { createSlice } from '@reduxjs/toolkit';

const selectedCheckListSlice = createSlice({
    name: 'checkListDatail',
    initialState: { checkListDatails:null },
    reducers: {
        setcheckListDatail: (state, action) => {
            console.log("action",action.payload);
            state.checkListDatails = action.payload;
            // state.checkListDatail = action.payload;
        },

    },
});

export const { setcheckListDatail } = selectedCheckListSlice.actions;
export default selectedCheckListSlice.reducer;